import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Admin.css";
import axios from "axios";
import AdminSidebar from "./components/AdminSidebar";
import AdminHeader from "./components/AdminHeader";

import TextInput from "../components/TextInput";
import openNotification from "../components/OpenNotification";
import Loader from "../components/Loader";
import { DefaultEditor } from "react-simple-wysiwyg";

const Mailer = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [submitButton, setSubmitButton] = useState(false);
  const [templates, setTemplates] = useState([]);

  const [formData, setFormData] = useState({
    recipients: "",
    userGroup: "",
    subject: "",
    message: "",
    attachment: [],
    csvFile: null,
    scheduleTime: "",
    template: "",
    senderMail: "",
  });

  useEffect(() => {
    document.title = "Barterfunds Mailer | BarterFunds";

    fetchTemplates();
  }, []);

  useEffect(() => {
    const token = window.sessionStorage.getItem("token");

    if (!token) {
      navigate("/login");
      return;
    }

    const isValid =
      (formData.message || formData.template) &&
      (formData.recipients || formData.userGroup || formData.csvFile) &&
      formData.subject;

    setSubmitButton(isValid);
    setIsLoading(false);
  }, [navigate, formData]);

  const fetchTemplates = () => {
    const token = window.sessionStorage.getItem("token");

    setIsLoading(true);

    axios
      .get(`${process.env.REACT_APP_API_URL}/email-templates`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        if (res.data.success) {
          setTemplates(res.data.templates);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching templates", err);
        setIsLoading(false);
      });
  };

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "attachment") {
      setFormData((prevState) => ({
        ...prevState,
        attachment: files[0],
      }));
    } else if (name === "csvFile") {
      setFormData((prevState) => ({
        ...prevState,
        csvFile: files[0],
      }));
    } else if (name === "template") {
      if (value) {
        // Find selected template object
        const selectedTemplate = templates.find((tpl) => tpl._id === value);

        setFormData((prevState) => ({
          ...prevState,
          template: value,
          message: selectedTemplate ? selectedTemplate.content : "",
        }));
      } else {
        setFormData((prevState) => ({
          ...prevState,
          template: "",
          message: "",
        }));
      }
    } else {
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  const handleEditorChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      message: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const token = window.sessionStorage.getItem("token");
    const form = new FormData();

    form.append("recipients", formData.recipients);
    form.append("userGroup", formData.userGroup);
    form.append("subject", formData.subject);
    form.append("message", formData.message);
    form.append("scheduleTime", formData.scheduleTime);
    form.append("templateId", formData.template);
    form.append("senderMail", formData.senderMail);

    if (formData.attachment) {
      form.append("attachment", formData.attachment);
    }
    if (formData.csvFile) {
      form.append("csvFile", formData.csvFile);
    }

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/mailer/send-bulk-email`,
        form,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      // console.log("Response Data:", res.data);

      if (res.data.success) {
        openNotification(
          "topRight",
          "success",
          "Email(s) Sent",
          res.data.message || "Email(s) sent successfully."
        );

        setTimeout(() => {
          window.location.reload();
        }, 2000);
      } else {
        openNotification(
          "topRight",
          "error",
          "Error",
          "Error sending email(s)"
        );
      }
    } catch (err) {
      openNotification(
        "topRight",
        "error",
        "Error",
        err?.response?.data?.message || err.message
      );
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="page-wrapper default-version">
      <AdminSidebar active={"mailer"} />
      <AdminHeader />
      <>
        {isLoading ? (
          <Loader />
        ) : (
          <div className="body-wrapper">
            <div className="bodywrapper__inner">
              <div className="d-flex mb-30 flex-wrap gap-3 justify-content-between align-items-center">
                <h6 className="page-title">Send Email</h6>
                <div className="d-flex flex-wrap justify-content-end gap-2 align-items-center breadcrumb-plugins">
                  {/* <button
                    onClick={handleBack}
                    className="btn btn-sm btn-outline--primary"
                  >
                    <i className="la la-undo" /> Back
                  </button> */}
                </div>
              </div>

              <form onSubmit={handleSubmit} encType="multipart/form-data">
                <div className="card">
                  <div className="card-body row gy-4 px-2">
                    <div className="col-md-6">
                      <TextInput
                        label="Manual Recipients (comma separated)"
                        inputname="recipients"
                        inputtype="text"
                        placeholder="email1@example.com, email2@example.com"
                        onValueChange={handleChange}
                        value={formData.recipients}
                      />
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label>User Group</label>
                        <select
                          name="userGroup"
                          className="form-control"
                          onChange={handleChange}
                          value={formData.userGroup}
                        >
                          <option value="">Select Group</option>
                          <option value="all">All Users</option>
                          <option value="verified">Verified Users</option>
                          <option value="inactive">Inactive Users</option>
                          <option value="unverified">Unverified Users</option>
                        </select>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Import CSV</label>
                        <input
                          type="file"
                          name="csvFile"
                          accept=".csv"
                          className="form-control"
                          onChange={handleChange}
                        />
                        <a
                          href="/assets/bulkSms.csv"
                          download
                          className="mt-5 text-sm/6 text-blue-600 hover:underline"
                        >
                          Download CSV Template
                        </a>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <TextInput
                        label="Subject"
                        inputname="subject"
                        inputtype="text"
                        placeholder="Enter email subject"
                        onValueChange={handleChange}
                        value={formData.subject}
                      />
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Email Template</label>
                        <select
                          name="template"
                          className="form-control"
                          value={formData.template}
                          onChange={handleChange}
                        >
                          <option value="">No Template</option>
                          {templates.map((tpl) => (
                            <option key={tpl._id} value={tpl._id}>
                              {tpl.title}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Sender Email</label>
                        <select
                          name="senderMail"
                          className="form-control"
                          value={formData.senderMail}
                          onChange={handleChange}
                        >
                          <option value="">Select Email</option>
                          <option value="michael@barterfunds.com">
                            michael@barterfunds.com
                          </option>
                          <option value="support@barterfunds.com">
                            support@barterfunds.com
                          </option>
                          <option value="business@barterfunds.com">
                            business@barterfunds.com
                          </option>
                          <option value="newsletter@barterfunds.com">
                            newsletter@barterfunds.com
                          </option>
                          <option value="contact@barterfunds.com">
                            contact@barterfunds.com
                          </option>
                          <option value="info@barterfunds.com">
                            info@barterfunds.com
                          </option>
                          <option value="compliance@barterfunds.com">
                            compliance@barterfunds.com
                          </option>
                          <option value="legal@barterfunds.com">
                            legal@barterfunds.com
                          </option>
                        </select>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form-group">
                        <label>Message</label>
                        <DefaultEditor
                          name="message"
                          value={formData.message}
                          onChange={handleEditorChange}
                          rows={10}
                          disabled={formData.template}
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <label>Attachments (optional)</label>
                      <input
                        type="file"
                        name="attachment"
                        className="form-control"
                        onChange={handleChange}
                        multiple
                      />
                    </div>

                    <div className="col-md-6">
                      <label>Schedule Time (optional)</label>
                      <input
                        type="datetime-local"
                        name="scheduleTime"
                        className="form-control"
                        value={formData.scheduleTime}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="col-12">
                      <button
                        type="submit"
                        className="btn btn--primary w-100 h-45 center"
                        disabled={!submitButton}
                      >
                        {formData.scheduleTime ? "Schedule" : "Send"} Email
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        )}
      </>
    </div>
  );
};

export default Mailer;
